import { PvAnalysisVariationRoofSegment } from './pv-analysis.dto';

/**
 * Builds a unique ID for a roof segment based on its properties and indices.
 * Thus, it is suitable as a key to be used in React lists.
 * @param buildingIndex Index in the list of buildings
 * @param roofSegmentIndex Index in the list of roof segments
 * @param segment The segment itself
 * @returns The unique ID for the roof segment
 */
export function buildUniqueRoofSegmentId(
    buildingIndex: number,
    roofSegmentIndex: number,
    segment: PvAnalysisVariationRoofSegment,
): string {
    return `${buildingIndex + 1}:${roofSegmentIndex + 1}:${segment.azimuthDegrees}:${segment.tiltDegrees}:${segment.kwp}:${segment.kwhPerKwp}`;
}

/**
 * Generates a human-readable numbering for a roof segment.
 * @param buildingIndex Index in the list of buildings
 * @param roofSegmentIndex Index in the list of roof segments
 * @returns Numbering
 */
export function buildRoofSegmentNumbering(buildingIndex: number, roofSegmentIndex: number) {
    return `${buildingIndex + 1}:${roofSegmentIndex + 1}`;
}
